import { createRoute } from '@tanstack/react-router'
import { lawyerRoute } from './index'
import { DashboardPage } from '@/components/lawyer/dashboard'

export const lawyerDashboardRoute = createRoute({
  getParentRoute: () => lawyerRoute,
  path: '/dashboard',
  component: DashboardPage,
})
